// extracted by mini-css-extract-plugin
export default {"icon":"webpack-concepts-Documents-DocumentLinks-module__icon"};